import Navbar from '../../components/Navbar'
import Footer from '../../components/Footer'
import CampaignCard from './components/CampaignCard'
import DonationForm from './components/DonationForm'
import { useEffect, useState } from 'react'
import { supabase } from '../../lib/supabase'

export default function Welfare() {
  const [campaigns, setCampaigns] = useState([])
  const [selected, setSelected] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchCampaigns = async () => {
      const { data } = await supabase
        .from('welfare_campaigns').select('*').order('created_at', { ascending: false })
      if (data) setCampaigns(data)
      setLoading(false)
    }
    fetchCampaigns()
  }, [])

  return (
    <div className="relative min-h-screen bg-white dark:bg-black text-gray-900 dark:text-white flex flex-col overflow-hidden">

      {/* Watermark */}
      <div
        className="absolute inset-0 bg-center bg-no-repeat bg-contain opacity-[0.08] dark:opacity-[0.06] pointer-events-none"
        style={{ backgroundImage: "url('/images/dsms_watermark.png')" }}
      />

      <Navbar />
      <div className="relative z-10 flex-1 px-4 sm:px-6 lg:px-8 py-6 lg:py-10 max-w-6xl mx-auto w-full">
        <div className="mb-6 lg:mb-10">
          <h1 className="text-2xl lg:text-4xl font-black uppercase tracking-tight mb-2">
            Community Welfare
          </h1>
          <p className="text-gray-500 text-sm">Supporting our members in times of need</p>
        </div>

        {loading ? (
          <div className="text-gray-500 text-sm uppercase tracking-widest text-center py-10">
            Loading campaigns...
          </div>
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-6">
            {campaigns.map((campaign) => (
              <CampaignCard key={campaign.id} campaign={campaign} onDonate={() => setSelected(campaign)} />
            ))}
          </div>
        )}
      </div>

      {selected && <DonationForm campaign={selected} onClose={() => setSelected(null)} />}
      <Footer />
    </div>
  )
}